<div *ngIf="this.label" class="form-group">
	<div class="row">
		<div class="col pair-left"><wd-text-input [(model)]="model!.neu!" [name]="name + 'Neu'" label="{{label}}" [hideComments]="hideComments"></wd-text-input></div>
		<div class="col pair-right col-auto"> <wd-text-input [(model)]="model!.alt" [name]="name + 'Alt'" label="...alt" [hideComments]="hideComments"></wd-text-input></div>
	</div>
</div>
<div *ngIf="!this.label" class="row">
	<div class="col pair-left"><wd-text-input [(model)]="model!.neu!" [name]="name + 'Neu'" [hideComments]="hideComments"></wd-text-input></div>
	<div class="col pair-right col-auto"><wd-text-input [(model)]="model!.alt" [name]="name + 'Alt'" placeholder="alt" [hideComments]="hideComments"></wd-text-input></div>
</div>
